import AppMessageUtils from '@/utils/appMessage.utils';
import Axios from 'axios';
import { userManager } from '@/store/modules/auth.module';

const httpAxios = Axios.create();

httpAxios.interceptors.request.use(
  async (config) => {
    const reqConfig = config;
    const user = await userManager.getUser();
    if (user && !user.expired) {
      const token = user.access_token;
      reqConfig.headers.Authorization = `Bearer ${token}`;
    } else {
      AppMessageUtils.error('Token expired, Please login again');
      setTimeout(async () => {
        await userManager.removeUser();
        await userManager.revokeTokens();
        userManager.signoutRedirect();
      }, 3000);
    }
    return reqConfig;
  },
  (error) => {
    // eslint-disable-next-line no-console
    console.log(error);
    return Promise.reject(error);
  },
);

httpAxios.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error),
);

export default httpAxios;

export const httpAxiosPublic = Axios.create();
